import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * RootRedirect
 * - Logged in → /dashboard (DashboardRouter then picks Admin vs User view)
 * - Not logged in → /login
 *
 * Replaces the public marketing landing page at "/". Always returns one of the
 * two destinations after a quick auth probe; never renders any content the
 * unauthenticated public could see.
 */
export default function RootRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    // No token, no cookie → skip the API round-trip
    const hasLocalToken = !!localStorage.getItem("session_token");
    const hasSessionCookie = document.cookie.split(";").some((c) => c.trim().startsWith("session_token="));
    if (!hasLocalToken && !hasSessionCookie) {
      navigate("/login", { replace: true });
      return;
    }
    axios
      .get(`${API}/auth/me`)
      .then((res) => {
        if (res.data) {
          navigate("/dashboard", { replace: true });
        } else {
          navigate("/login", { replace: true });
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          localStorage.removeItem("session_token");
        }
        navigate("/login", { replace: true });
      });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--background))]">
      <Loader2 className="w-8 h-8 animate-spin text-[hsl(var(--primary))]" />
    </div>
  );
}
